import { ClinicalWaitingListsSortOrderType, SortDirection } from "@/Common/Models/UI/Enums";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { RequestMapper, ServerResponseMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { RouterHistory } from "@/Common/Utilities/Router/RouterHistory";
import { IListCreateAndEditItemModel } from "../Models/UI/IListCreateAndEditItemModel";
import { IListModel } from "../Models/UI/IListModel";
import { IListsTabModel } from "../Models/UI/IListsTabModel";
import { IListsTreeModel } from "../Models/UI/IListsTreeModel";
import { ListsAction } from "./Actions/ListsAction";
import { ListsHandler } from "./Handlers/Local/ListsHandler";
import { ListsResponseHandler } from "./Handlers/Server/ListsResponseHandler";

let defaultInstance: ListsStore;

class ListsStore extends BaseStore {
    // Mapper
    private Mapper: RequestMapper;
    private ServerMapper: ServerResponseMapper;

    // Hander
    private ListsHandler: ListsHandler;
    private ResponseHandler: ListsResponseHandler;

    private defaultListModel;
    private defaultCreateAndEditItemModel;

    // Models
    public ListsTabModel: IListsTabModel;
    public ListModel: IListModel;
    public ListsTreeModel: IListsTreeModel;
    public ListCreateAndEditItemModel: IListCreateAndEditItemModel;

    // Action
    public ListsAction: ListsAction;

    // default load
    public defaultsLoaded: boolean;

    constructor() {
        super();

        var self = this;

        // set default load
        this.defaultsLoaded = false;

        // set default Model
        var defaultListsTabModel = {
            ClinicalWaitingLists: [],
            ShowAddNewListPopup: false,
            IsAnyListSelected: false,
            SelectedList: "",
            SearchMenuOpen: true,
            SearchText: "",
            PageSize: 0
        };

        self.defaultListModel = {
            ListId: "",
            ListName: "",
            ListCount: 0,

            PageSizeOptions: [20, 30, 40, 50],
            TotalQueryRows: "",
            CurrentPage: 0,
            TotalQueryPages: "",

            GlobalSearchText: "",
            GlobalSearchPlaceholder: cacheStore.GetString("SearchLabel"),
            SelectedPageNumber: 1,
            SelectedPageSizeOption: 20,
            OrderByColumn: ClinicalWaitingListsSortOrderType[ClinicalWaitingListsSortOrderType.Patient],
            OrderByDirection: SortDirection[SortDirection.DESC],

            TableData: [],
            ColumnOrderingPopupOpen: "",

            ShowDisplaySettings: false,
            ShowEditListNamePopup: false,
            ShowDeleteListPopup: false,
            SelectedItem: "",
            SelectedPatientForList: ""
        };

        self.defaultCreateAndEditItemModel = {
            ListId: "",
            SelectedPatientForList: "",
            Priority: 3,
            Comments: "",
            SelectedItem: "",

            ShowSearchPatientPopup: false,
            ShowSelectedPatientPopup: false,
            ShowDeleteListItemPopup: false,
            IsSelectedPatientExists: false,
            OpenEditItemPopup: false

        };

        this.ListsTabModel = Immutable.fromJS(defaultListsTabModel);
        this.ListModel = Immutable.fromJS(self.defaultListModel);
        this.ListCreateAndEditItemModel = Immutable.fromJS(self.defaultCreateAndEditItemModel);

        // instantiate Actions
        this.ListsAction = new ListsAction();

        // instantiate Handlers
        this.ListsHandler = new ListsHandler();

        // Instantiation and set mapper
        this.Mapper = new RequestMapper();
        this.ServerMapper = new ServerResponseMapper();
        this.Mapper.AddInstance(this.ListsHandler);
        this.ResponseHandler = new ListsResponseHandler(this.ListsAction);
        this.ServerMapper.AddInstance(this.ResponseHandler);

        // Register dispatchers
        this.ClientDispatchToken = LocalEventDispatcher.register((request: LocalEvent) => self.Mapper.Map(request, self));

        this.ServerDispatchToken = ServerResponseDispatcher.register((response: ServerEvent) => { self.ServerMapper.Map(response, self); });
    }

    public static createSingleton(): ListsStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new ListsStore());
    }

    public static createSingletonFrom(store: ListsStore, copy: boolean = true): ListsStore {
        return copy
            ? Object.assign(this.createSingleton(), store)
            : this.createStoreSingleton(defaultInstance, () => defaultInstance = store);
    }

    public InitializeListModel(): void {
        this.ListModel = Immutable.fromJS(this.defaultListModel);
    }

    public InitializeListCreateAndEditItemModel(): void {
        this.ListCreateAndEditItemModel = Immutable.fromJS(this.defaultCreateAndEditItemModel);
    }

    public ShowListTab(): void {
        window.setTimeout(() => {
            if (!RouterHistory.location.pathname.endsWith("/lists")) {
                RouterHistory.push("lists");
                this.EmitChangeToListeners();
            }
        }, 0);
    }
}

export { ListsStore, defaultInstance as listsStore };
